var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _ellipse, _polygon2, _g, _g2, _path11, _path12, _circle2, _path13, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete_Question",
    "data-name": "Delete Question",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 312.64 225.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#006aea;}.cls-2{fill:#c9e1ff;}.cls-3{fill:#2e83ea;}.cls-4{fill:#94d9f2;}.cls-5{fill:#e4f0f9;}.cls-6{fill:#75b2fc;}.cls-7{fill:#95c3fa;}.cls-8{fill:#defff5;stroke:coral;stroke-width:6px;}.cls-10,.cls-12,.cls-8{stroke-miterlimit:10;}.cls-9{fill:coral;}.cls-10{fill:#c6dbda;stroke:#fff;}.cls-11{fill:#fcfcfc;}.cls-12{fill:#f4f4f4;stroke:#d0e6ef;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 243.98,
    cy: 6.64,
    r: 5.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2078,359.46c7.22,3.05,9.06,18.07,4.86,28.71-4.92,12.52-17.74,17.88-32.36,24a126.57,126.57,0,0,1-36.67,9.17c30.15-9.87,39.14-21.63,41.39-31,1.9-7.92-.44-16.51,6.16-24.13C2065.48,361.46,2072.85,357.28,2078,359.46Z",
    transform: "translate(-1826.69 -216.66)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2056.34,267.17H1866.21c-5.41,0-9.79-5.29-9.79-11.82v-1.41a13.14,13.14,0,0,1,2.87-8.36,10.38,10.38,0,0,1,6.92-3.46c61.93-7.46,92.79-7.43,92.79-7.43s36,0,97.34,7.43a10.38,10.38,0,0,1,6.93,3.46,13.14,13.14,0,0,1,2.87,8.36v1.41C2066.14,261.88,2061.75,267.17,2056.34,267.17Z",
    transform: "translate(-1826.69 -216.66)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2018.42,377.56",
    transform: "translate(-1826.69 -216.66)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2028.36,382.31",
    transform: "translate(-1826.69 -216.66)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1994.58,415c-5.75,1.6-17.58,1.43-41.25,1.1-21.47-.3-32.2-.45-37.29-1.92-11.32-3.26-25.68-12.89-41.82-62.68a386,386,0,0,1-17.8-92.2c33.55-1.29,69.35-1.82,107.15-1.26,32.31.47,63.07,1.7,92.16,3.46a400,400,0,0,1-19.44,91.9C2019.67,402.54,2005.86,411.9,1994.58,415Z",
    transform: "translate(-1826.69 -216.66)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2062,261.38c-29.7,2.68-62.79,4.5-98.75,4.67-40.34.19-77.17-1.73-109.79-4.67a6.59,6.59,0,0,1-3.86-1.24,3.83,3.83,0,0,1-1.59-3v-7.7c0-2.33,2.44-4.23,5.45-4.23,31.44,2.87,66.92,4.79,105.77,4.74,37.66-.05,72.11-1.94,102.77-4.74a6.58,6.58,0,0,1,3.85,1.24,3.81,3.81,0,0,1,1.6,3v7.7Z",
    transform: "translate(-1826.69 -216.66)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1890.82,306.2c5.56,48.89,19.38,89.49,23.22,93.92.3.35,2.06,2.22,1.7,4.05a3.64,3.64,0,0,1-2.35,2.49c-6.22,1.35-27.32-67.18-28.29-70.38-13.89-45.42-16.1-60.18-10.26-64.29a7.17,7.17,0,0,1,6.38-.75C1888.31,273.89,1888.83,288.75,1890.82,306.2Z",
    transform: "translate(-1826.69 -216.66)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1983.17,362.06c-2.27,3.79-7,3.37-31.51,3.1-25.91-.29-30.7.08-32.86-3.8-3.21-5.76,2.68-15,11.28-28.51,9-14.05,13.61-21.35,20.57-21.55,8.26-.24,14.35,9.64,22.56,22.95C1980.47,346,1986.71,356.12,1983.17,362.06Z",
    transform: "translate(-1826.69 -216.66)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1949.52,342.18l-.66-10.7c-.13-2.08-.19-3.58-.19-4.48a4.25,4.25,0,0,1,.91-2.9,3,3,0,0,1,2.39-1,2.38,2.38,0,0,1,2.4,1.33,9.66,9.66,0,0,1,.6,3.83c0,1,0,2-.14,3l-.9,11a9.23,9.23,0,0,1-.63,3,1.62,1.62,0,0,1-1.58,1.05,1.57,1.57,0,0,1-1.57-1A11,11,0,0,1,1949.52,342.18Zm2.32,14.69a3.14,3.14,0,0,1-2.22-.88,3.22,3.22,0,0,1-.95-2.47,3.28,3.28,0,0,1,.91-2.35,2.91,2.91,0,0,1,2.22-1,3,3,0,0,1,2.24,1,3.57,3.57,0,0,1,0,4.81A3.12,3.12,0,0,1,1951.84,356.87Z",
    transform: "translate(-1826.69 -216.66)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2019.72,308c-5.56,48.89-19.38,89.49-23.22,93.92-.3.36-2,2.23-1.7,4.05a3.62,3.62,0,0,0,2.35,2.49c6.22,1.36,27.32-67.18,28.29-70.37,13.9-45.43,16.11-60.19,10.26-64.29a7.17,7.17,0,0,0-6.38-.75C2022.23,275.65,2021.71,290.51,2019.72,308Z",
    transform: "translate(-1826.69 -216.66)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "229.15 178.66 156.85 99.77 239.66 6.22 311.96 85.11 229.15 178.66"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 2109.13,
    cy: 277.99,
    rx: 2.51,
    ry: 1.26,
    transform: "translate(-86.35 2156.5) rotate(-87.53)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "167.69 115.63 249.99 156.62 310.68 41.65 228.37 0.67 167.69 115.63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doc-Face"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.95 44.51 279.71 66.7 281.13 63.75 233.37 41.56 231.95 44.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "232.91 57.73 266.29 73.24 267.71 70.29 234.34 54.78 232.91 57.73"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Doc-Face-2",
    "data-name": "Doc-Face"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "210.51 86.99 258.27 109.18 259.69 106.23 211.93 84.04 210.51 86.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "211.47 100.21 244.85 115.72 246.27 112.77 212.89 97.26 211.47 100.21"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1921.06,131.68",
    transform: "translate(-1826.69 -216.66)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1848,349.87c11.37,1.32,6.62,34.07,28.21,60.36,16.85,20.51,42,27.69,60.07,30.59-37.7-4.13-64-16.19-79.43-25.05-24.7-14.15-28.19-23.73-29.19-29.16C1824.46,369,1838.82,348.8,1848,349.87Z",
    transform: "translate(-1826.69 -216.66)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 281.13,
    cy: 9.14,
    r: 8.48
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1826.9,335.49c1.48-5.25,11-4.68,17.72-1.57a21.94,21.94,0,0,1,8.35,6.13c4.45,5.44,4.46,11,6.51,18.27,1.58,5.53,4.7,13.28,11.56,22.68a66.32,66.32,0,0,1-21.16-12C1838.71,359.71,1824.84,342.78,1826.9,335.49Z",
    transform: "translate(-1826.69 -216.66)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 49.45,
    cy: 173.44,
    r: 3.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.84,
    cy: 184.2,
    r: 1.29
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 124.02,
    cy: 220.97,
    r: 4.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteQuestion);
export default __webpack_public_path__ + "static/media/DeleteQuestion.d4046490fc6ddd605ac199dd0c232093.svg";
export { ForwardRef as ReactComponent };